module.exports = __webpack_public_path__ + "media/img/iryo/inicial-superior-d09cf945e21de75597a13047bf41ecb3.png";